export const currencyFormatter = new Intl.NumberFormat('th', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export default currencyFormatter;
